import React, { Component } from 'react';
import { Spinner } from '../../assets/loader/Spinner'
import logo from '../../assets/Images/design_-removebg-preview.png'
import innovate from '../../assets/Images/innovative.png'
import customer from '../../assets/Images/customer.png'
import quality from '../../assets/Images/quality.png'
import relation from '../../assets/Images/relation.png'
import result from '../../assets/Images/result.png'
import teamwork from '../../assets/Images/teamwork.png'
import './HomeStyle.css'
import Customer_care from '../../assets/Images/Customer_care.jpg'
import Customer_care_bg from '../../assets/Images/Customer_care_bg.png'


export class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };
  }

  handleNavigationStart = () => {
    this.setState({ loading: true });
  };

  handleNavigationEnd = () => {
    this.setState({ loading: false });
  };

  render() {
    const { loading } = this.state;

    return (
      <div>
        {loading && <Spinner />}  {/* Conditionally render the spinner */}

        {/* You can trigger loading as per your logic */}
        <div className='bg_img'>
          <div className="row ">
            <div className="col-lg-6 col-md-12 col-sm-12 ">

              <img src={logo} className="responsive-image" />
            </div>

            <div className="col-lg-5 col-md-12 col-sm-12 text_color">
              <h1>Empowering <span className='text_INNOV_color'>Businesses</span> with <span className='Prod_H_text'>Innovative</span>  Software Solutions</h1>
              <p>We specialize in document management, loan document tracking ssolutions,Report Management Systems, and customized software for NBF banks.</p>
              <button className='btn btn-primary'>Know More</button>
            </div>
          </div>

          {/* cards of the models starts */}

          <div className='row justify-content-center'>


            <div className='card card_style col-lg-3 col-md-3 col-sm-3'>

              <h3 className='Prod_H_text'>Document Tracking System</h3>
              <ul>
                <li>Real-time Document Tracking</li>
                <li>User Access Management</li>
                <li>Customizable Workflows</li>
                <li>Automated Notifications</li>
                <li>Report</li>
              </ul>
            </div>
            <div className='card card_style_1 col-lg-3 col-md-3 col-sm-3'>
              <h3 className='Prod_H_text_1'>Loan closure,Retrieval & Refilling</h3>
              <ul>

                <li>Need-Based Retrieval</li>
                <li>Multiple Level Approval</li>
                <li>Customer NOC upload</li>
                <li>Intelligent Search</li>
                <li>Compliance Management</li>
                <li>Notification System</li>

              </ul>
            </div>
            <div className='card card_style_2 col-lg-3 col-md-3 col-sm-3'>
              <h3 className='Prod_H_text_2'>File Inventory System</h3>
              <ul>
                <li>File Inward</li>
                <li>Document Acknowledgement</li>
                <li>Courier Management</li>
                <li>Barcoding data handling</li>
              </ul>

            </div>

          </div>
        </div>

        {/* cards of the models ends */}
        {/*  background image start */}
        <div className='row imagesStyle'>
          <div className='col-6 col-md-6 col-lg-6 col-sm-6'>
            <p className="text_style "> Our innovative application provides a seamless solution for NBF banks in India, designed to streamline the entire loan processing and document management workflow. Tailored for teams such as the Loan Approval Team, RMS Team, and others, our system enhances productivity and ensures smooth operations at every stage.
            </p>
            <p className="text_style1">The application offers robust features for document retrieval and refilling, allowing teams to quickly access and update necessary documents, ensuring accurate and up-to-date records are always available. Additionally, it serves as a powerful record management system, securely storing and organizing all loan-related documents for easy retrieval, ensuring compliance and efficient workflow.
            </p>
            <p className="text_style1">With these capabilities, the system empowers teams to efficiently manage documents at every stage, from initial loan approval to closure, offering enhanced collaboration, real-time insights, and a fully integrated approach for better decision-making and productivity.
            </p>
          </div>

          <div className='row col-6 col-md-6 col-lg-6 col-sm-6'>
            <div className='  col-5 col-md-5'>
              <div className='card p_model '>
                <h1>FTS </h1>
                <h5>Emphasizing Document Tracking System</h5>
              </div>

            </div>
            <div className='  col-6 col-md-6'>
              <div className='card p_model1 '>
                <h1>Loan Closure </h1>
                <h5>Accurate finalization and secure archiving</h5>
              </div>

            </div>


            <div className='  col-6 col-md-6'>
              <div className='card p_model3  '>
                <h1>Retrieval </h1>
                <h5>Ensures quick & Efficient access</h5>
              </div>

            </div>

            <div className='  col-6 col-md-6'>
              <div className='card p_model4 '>
                <h1>Refilling </h1>
                <h5>Efficient document handling and secure storage</h5>
              </div>

            </div>


          </div>




        </div>

        {/*  background image end */}

        {/*         models starts */}

        <div className='row '>
          <div className='card  color_style col-lg-12 col-md-12 col-sm-12'>
            <div className=' d-flex justify-content-center ' >
              <div className='card  card_line_style  col-lg-12 col-md-12 col-sm-12 mt-4 mb-4'>

              </div>

            </div>

            <div className='card-headers'>
              <h3> Our design and</h3>

            </div>
            <div className='card-headers'>
              <h2> Development Approach</h2>

            </div>

            <div className='row justify-content-center'>

              <div className='card card_dev_type card_style_2 col-lg-4 col-md-4 col-sm-4'>
                <div className='row mt-3 ml-1'>

                  <div className='col-lg-12 col-md-12 col-sm-12'>

                    <div className='card-headers approch-headers '>
                      UX Driven Engineering
                    </div>
                    <div className='card icon_car col-lg-3 col-md-3 col-sm-3 '>

                    </div>
                    <p style={{ textAlign: 'justify', fontSize: 15 }}>
                      Every feature is crafted to align with how your users think and operate.
                      We develop mockups and interactive prototypes to visualize and refine the application’s functionality.Our approach minimizes friction, making your application easy to navigate and engaging for all users.
                    </p>  </div>
                </div>
              </div>
              <div className='card card_dev_type card_style_2 col-lg-4 col-md-4 col-sm-4'>
                <div className='row mt-3 ml-1 mb-2'>

                  <div className='col-lg-12 col-md-12 col-sm-12'>

                    <div className='card-headers approch-headers  ' >
                      Developing Shared Understanding
                    </div>
                    <div className='car icon_card_d col-lg-3 col-md-3 col-sm-3  ' >

                    </div>
                    <p style={{ textAlign: 'justify', fontSize: 15 }}>
                      We believe that collaboration and clear communication are key to building software that truly meets your needs. Developing a shared understanding ensures all stakeholders—clients, designers, developers, and testers—are on the same page.
                      Wireframes, flowcharts, and diagrams bridge the gap between technical details and business goals
                    </p>  </div>
                </div>
              </div>


            </div>


            <div className='row justify-content-center'>

              <div className='card card_dev_type card_style_2 col-lg-4 col-md-4 col-sm-4'>
                <div className='row mt-3 ml-1 mb-2'>

                  <div className='col-lg-12 col-md-12 col-sm-12'>

                    <div className='card-headers approch-headers ' >
                      Proven Experience and Expertise
                    </div>
                    <div className='car icon_card_d col-lg-3 col-md-3 col-sm-3 '>

                    </div>
                    <p style={{ textAlign: 'justify', fontSize: 15 }}>
                      Our team brings years of experience and a deep understanding of software development to deliver solutions tailored to your business challenges.Expertise in various domains, from fintech to logistics. Skilled in modern tech stacks, frameworks, and tools, ensuring scalable and maintainable solutions.

                    </p> </div>
                </div>
              </div>

              {/* <div className='card card_dev_type col-lg-4 col-md-4 col-sm-4'>
                <div className='row mt-3 ml-1 mb-2'>
                  <div className='card icon_card_ col-lg-3 col-md-3 col-sm-3 '>

                  </div>
                  <div className='col-lg-10 col-md-10 col-sm-10'>

                    <div className='card-headers ' style={{ fontWeight: 'bold', textAlign: 'justify' }}>
                      Security & Intellectual Property (IP)
                    </div>
                    <p style={{ textAlign: 'justify', fontSize: 15 }}>Unlike other companies, we are a UX first development company. Projects are driven by designers and they make sure design and experiences translate to code.</p>
                  </div>
                </div>
              </div> */}
              <div className='card card_dev_type card_style_2 col-lg-4 col-md-4 col-sm-4'>
                <div className='row mt-3 ml-1 mb-2'>

                  <div className='col-lg-12 col-md-12 col-sm-12'>

                    <div className='card-headers approch-headers ' >
                      Code Reviews
                    </div>
                    <div className='card icon_card_d col-lg-3 col-md-3 col-sm-3 '>

                    </div>
                    <p style={{ textAlign: 'justify', fontSize: 15 }}>
                      Quality code is the foundation of a reliable software application. We adhere to a rigorous code review process to ensure Clean, well-documented code makes future enhancements and debugging easier. Identifying bottlenecks early to deliver a fast, responsive application

                    </p> </div>
                </div>
              </div>

            </div>

            <div className='row justify-content-center'>



              <div className='card card_dev_type card_style_2 col-lg-4 col-md-4 col-sm-4'>
                <div className='row mt-3 ml-1 mb-2'>

                  <div className='col-lg-12 col-md-12 col-sm-12'>

                    <div className='card-headers approch-headers ' >
                      Quality Assurance & Testing
                    </div>
                    <div className='car icon_card_d col-lg-3 col-md-3 col-sm-3 '>

                    </div>
                    <p style={{ textAlign: 'justify', fontSize: 15 }}>

                      Delivering a flawless application is our commitment. Our QA and testing process guarantees With a focus on quality, we ensure your application performs seamlessly, providing a reliable and delightful experience for your users

                    </p> </div>
                </div>
              </div>

            </div>

          </div>

        </div>

        {/*         models ends */}
        <div className='row '>
          <div className='card  color_style mt-1 col-lg-12 col-md-12 col-sm-12'>


            <div className='card-headers whyBgImg'>
              <h3 className='pt-4 headersize'> Why LAST- LaxmAnjali SoftTech ?</h3>
              <p className='textsize'>"Leading Advanced Solutions Today –  Crafting Tomorrow's Tech  Excellence"</p>
              <div className='row justify-content-center'>
                <div className='card p_model_why m-2  '>

                  <img className='why_img' src={innovate} />
                  <h3>Innovative Solutions</h3>
                </div>





                <div className='card p_model_why mx-4 '>
                  <img className='why_img' src={result} />

                  <h3>Proven Result</h3>
                </div>


                <div className='card p_model_why  mx-4 mt-4'>
                  <img className='why_img' src={quality} />
                  <h5>Quality Assurance</h5>
                </div>


                <div className='card p_model_why '>
                  <img className='why_img' src={teamwork} />
                  <h5>Team Work</h5>
                </div>

                <div className='row justify-content-center'>
                  <div className='card p_model_why mx-4 '>
                    <img className='why_img' src={customer} />
                    <h5>Smooth Customer Experience</h5>
                  </div>


                  <div className='card p_model_why '>
                    <img className='why_img' src={relation} />
                    <h5>Strong Client Relationships</h5>
                  </div>

                </div>

              </div>
            </div>
          </div>
        </div>

        <div className='bg_img'>
          <div className='outer-container '>
            <div class="box-border">
              <div class="box-with-cut">
                <h4 className='our-purpose'>Our Purpose  :</h4>
                <h6>  To harness the power of innovative software solutions and amplify human potential, creating opportunities for businesses and communities.</h6> </div>
            </div>
          </div>

          <div className='outer-container p-1 '>
            <div class="box-border">
              <div class="box-with-cut">
              <h4 className='our-purpose'>Our Goals  :</h4>
                <h6> To streamline workflows, enhance efficiency, and drive transparency, transforming complex processes into seamless and user-friendly experiences.</h6> </div>
            </div>
          </div>
<div className='row box_cust_style'>
  <div className='col-6'>
          <img src={Customer_care} alt='Customer_care' className='Customer_Care' />
          {/* <img src={Customer_care_bg} alt='Customer_care'/> */}
          </div>
          <div className='col-6'>
<span className='content_style'>We are available here </span>

<div className='row'>
<div className='col-12 ' > <p className='contact_style'></p></div>
<div className='col-12 contact_style'>bussinesssales@laxmanjaligroup.com</div>
          </div>
          </div>
        
          </div>
        </div>

      </div>
    );
  }
}

// <button onClick={this.handleNavigationStart}>Start Loading</button>
// <button onClick={this.handleNavigationEnd}>End Loading</button>